import t from "../../theme";

export const useGetScrollToTopButtonStyles = (variant) => {
  return {
    button: {
      position: variant === "absolute" ? "absolute" : "fixed",
      bottom: variant === "absolute" ? "20px" : "28px",
      right: variant === "absolute" ? "20px" : "28px",
      zIndex: 5,
      width: "42px",
      height: "42px",
      borderRadius: t.radius.circle,
      border: "none",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      background: t.green.gradient,
      color: t.text.inverse,
      boxShadow: t.shadow.md,
      transition: t.transition.fast,
      "&:hover": {
        boxShadow: t.shadow.brandFocus,
        transform: "translateY(-2px)",
      },
    },
  };
};
